export default __webpack_public_path__ + "static/media/hht1_storybook_19.9d52e58b.png";